import { useSelector } from 'react-redux';
import { ContactsGrowth } from '@dev/ee-api/ee-api-models';
import dayjs from '@/services/tools/dayjs';

import { getContactsGrowthStore } from '@/store/contacts/actions';

export interface GraphEntry {
    Day?: string;
    Contacts?: number;
}

const prepareGraphData = (data: ContactsGrowth[], contactsGrowthFrom: string): GraphEntry[] => {
    if (!data?.length) return [];

    const fromDate = dayjs(contactsGrowthFrom).add(1, 'day').startOf('day');
    const firstDataDate = dayjs(data[0].Day).startOf('day');
    const missingDays = firstDataDate.diff(fromDate, 'day');
    let missingDaysArray: GraphEntry[] = [];
    if (missingDays > 0) {
        missingDaysArray = new Array(missingDays).fill(1).map((value: number, index) => ({
            Day: firstDataDate.subtract(1 + index, 'day').format('MM-DD'),
            Contacts: 0,
        }));
        missingDaysArray = missingDaysArray.reverse();
    }
    const graphData = data.map(
        (entry): GraphEntry => ({
            Day: dayjs(entry.Day).format('MM-DD'),
            Contacts: entry.ActiveCount + entry.EngagedCount,
        })
    );
    return [...missingDaysArray, ...graphData];
};

interface ContactsGrowthData {
    formattedData: GraphEntry[],
    isGraphLoading: boolean,
    needExpandedYAxis: boolean,
}

export const useContactsGrowthData = (contactsGrowthFrom: string): ContactsGrowthData => {
    const contactsGrowth = useSelector(getContactsGrowthStore);
    
    if (contactsGrowth) {
        const formattedData = prepareGraphData(contactsGrowth, contactsGrowthFrom);
        return {
            formattedData,
            isGraphLoading: false,
            needExpandedYAxis: formattedData?.some((singleDay) => singleDay.Contacts / 100_000 > 1) // if contacts count is bigger than 100,000 than expand Y axis width so it will fit
        }
    }

    return {
        formattedData: null,
        isGraphLoading: true,
        needExpandedYAxis: false
    };
};
